import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components/native';

import { ElevatorPanel } from '../Components/ElevatorPanel/ElevatorPanel';
import { MapCloseButton } from '../Components/MapCloseButton';
import { MapPage } from '../Components/MapPage/MapPage';
import { useFloorMapPresenter } from '../FloorMapPresenter';
import { useFloorMapSizer } from '../FloorMapSizer';
import { MapLayoutLandscape } from './MapLayoutLandscape';

export const MapLandscape = observer(function MapLandscape() {
  const { title, floorsVM } = useFloorMapPresenter();
  const { titleHeight } = useFloorMapSizer();

  return (
    <MapLayoutLandscape
      pagesComponent={
        <MapContainer>
          {floorsVM.map((floor) => (
            <MapPage floorId={floor.id} key={floor.id} />
          ))}
        </MapContainer>
      }
      titleComponent={
        <MapTitle style={{ fontSize: titleHeight }}>{title}</MapTitle>
      }
      elevatorPanelComponent={<ElevatorPanel />}
      closeButtonComponent={<MapCloseButton />}
    />
  );
});

const MapContainer = styled.View`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
`;

const MapTitle = styled.Text`
  font-size: 50px;
  font-family: ${OwnableTheme.fonts.gilroy.regular};
  color: ${OwnableTheme.colors.white};
`;
